import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import moment from 'moment';

import {
    Button,
    Heading,
    Loading,
    Message,
    Modal,
    PrizeSpacer,
    Text,
    ValidatingInput,
    ValidatingSelect,
    ValidatingCheckbox,
    getMessage
} from '../';

import Formsy from '../../external/Formsy';
import taxProfileActions from '../../actions/TaxProfileActions';
import generateTaxRecordSchema from '../../data/schema/TaxRecordSchema';
import { statesFullNames, canadaProvinces, australiaStates } from '../../constants/Countries';
import Url from '../../constants/Url';
import svgs from '../../constants/svgs';
import Svg from '../common/svg/Svg';

const mapStateToProps = state => {
    return {
        locale: state.get('localization').get('locale'),
        messages: state.get('localization').get('messageProperties'),
        taxProfile: state.get('taxProfile').toJS()
    };
};

const mapDispatchProps = dispatch => {
    return {
        getInterviewUrl: locale => dispatch(taxProfileActions.getInterview(locale)),
        getTaxProfile: () => dispatch(taxProfileActions.getTaxProfile()),
        setForm: form => dispatch(taxProfileActions.setForm(form)),
        getTaxDocuments: () => dispatch(taxProfileActions.getTaxDocuments()),
        updateTaxProfile: patch => dispatch(taxProfileActions.updateTaxProfile(patch))
    };
};

class TaxProfileForm extends Component {
    static displayName = 'TaxProfileForm';

    static propTypes = {
        getInterviewUrl: PropTypes.func,
        getTaxProfile: PropTypes.func,
        history: PropTypes.object,
        locale: PropTypes.string,
        messages: PropTypes.object,
        setForm: PropTypes.func,
        taxProfile: PropTypes.object,
        firstCanRetakePrize: PropTypes.object,
        updateTaxProfile: PropTypes.func,
        getTaxDocuments: PropTypes.func,
        jumpToTab: PropTypes.func
    };

    state = {
        showGuardianModal: false,
        showRetakeModal: false,
        taxYear: null,
        taxYearDocuments: []
    };

    closeRetakeModal = () => {
        this.setState({showRetakeModal: false});
    };

    showRetakeModal = () => {
        const {firstCanRetakePrize, jumpToTab, taxProfile: { retakeAvailable }} = this.props;
        if (!retakeAvailable && firstCanRetakePrize) {
            jumpToTab();
        } else {
            this.setState({showRetakeModal: true});
        }
    }

    closeGuardianModal = () => {
        this.setState({showGuardianModal: false});
    }

    showGuardianModal = () => {
        this.setState({showGuardianModal: true});
    }

    getMsg = (code, args = []) => {
        return getMessage(this.props.messages, code, args);
    }

    onConfirm = () => {
        const { history, taxProfile: { url } } = this.props;
        history.push('interview', { taxInterviewUrl: url, isRetake: true });
    };

    getInterviewUrl = () => {
        const { getInterviewUrl, locale } = this.props;
        getInterviewUrl(locale);
        this.setState({showRetakeModal: true});
    };

    handleFieldChange = event => {
        const {
            setForm,
            taxProfile: { form }
        } = this.props;

        const newForm = {
            ...form,
            [event.target.name]: event.target.value || ''
        };
        setForm(newForm);
    }

    handleSwitchDiff = () => {
        const {
            setForm,
            taxProfile: { form }
        } = this.props;
        const newForm = {
            ...form,
            mailingAddressDifferent: !form.mailingAddressDifferent
        };
        setForm(newForm);
    }


    handleSubmit = () => {
        const { taxProfile: { form }, updateTaxProfile } = this.props;
        const {
            addressCity,
            addressLine1,
            addressLine2,
            addressPostCode,
            addressState,
            mailingAddressCity,
            mailingAddressLine1,
            mailingAddressLine2,
            mailingAddressPostCode,
            mailingAddressState,
            mailingAddressDifferent,
            guardianEmail,
            guardianFirstName,
            guardianLastName,
            guardianPhoneNumber
        } = form;

        const profilePatch = {
            addressCity,
            addressLine1,
            addressLine2,
            addressPostCode,
            addressState,
            mailingAddressCity,
            mailingAddressLine1,
            mailingAddressLine2,
            mailingAddressPostCode,
            mailingAddressState,
            mailingAddressDifferent,
            guardianEmail,
            guardianFirstName,
            guardianLastName,
            guardianPhoneNumber
        };

        Object.keys(profilePatch).forEach(key => profilePatch[key] === undefined && delete profilePatch[key]);
        updateTaxProfile(profilePatch);
    }

    handleModalSubmit = () => {
        this.handleSubmit();
        this.closeGuardianModal();
    }

    componentWillMount() {
        this.taxRecordSchema = generateTaxRecordSchema(this.props.messages);
    }

    componentDidMount() {
        const {
            getTaxProfile,
            taxProfile: { wasFetched }
        } = this.props;

        if (!wasFetched) {
            getTaxProfile();
        }
    }

    PermanentAddress = () => {
        const { taxProfile: { form } } = this.props;
        const {
            addressCity,
            addressLine1,
            addressLine2,
            addressPostCode,
            addressRegion,
            addressState,
            addressZipCode
        } = this.taxRecordSchema;

        // USA, Canada, Australia use predefine state lists
        const useSelect = ['US', 'CA', 'AU'].indexOf(form.addressCountryCode) > -1;
        let stateList;

        switch (form.addressCountryCode) {
            case 'US':
                stateList = statesFullNames;
                break;
            case 'CA':
                stateList = canadaProvinces;
                break;
            case 'AU':
                stateList = australiaStates;
                break;
            default:
                stateList = null;
        }
        return (<Fragment>
            <Heading className="col-xs-12 col-lg-12 tp-header" size={12}>{this.getMsg('epic.esport.profile.title.permanent')}</Heading>
            <ValidatingInput
                customClassNames="col-xs-12 col-lg-12 tp-input"
                disabled={!form.recordIdentityKey}
                maxLength={128}
                name={addressLine1.identifier}
                onChange={this.handleFieldChange}
                placeholder={this.getMsg('epic.esport.label.profile.address1')}
                required={addressLine1.required}
                validationErrors={addressLine1.validationMessages}
                validations={addressLine1.validations}
                value={form.addressLine1}
            />
            <ValidatingInput
                customClassNames="col-xs-12 col-lg-12 tp-input"
                disabled={!form.recordIdentityKey}
                maxLength={128}
                name={addressLine2.identifier}
                onChange={this.handleFieldChange}
                placeholder={this.getMsg('epic.esport.label.profile.address2')}
                required={addressLine2.required}
                validationErrors={addressLine2.validationMessages}
                validations={addressLine2.validations}
                value={form.addressLine2}
            />

            <ValidatingInput
                customClassNames="col-xs-12 col-lg-6 tp-input"
                disabled
                name="country"
                placeholder={this.getMsg('epic.esport.label.payoutInfo.country')}
                value={form.addressCountryCode}
            />
            <ValidatingInput
                customClassNames="col-xs-12 col-lg-6 tp-input"
                disabled={!form.recordIdentityKey}
                maxLength={128}
                name={addressCity.identifier}
                onChange={this.handleFieldChange}
                placeholder={this.getMsg('epic.esport.label.payoutInfo.city')}
                required={addressCity.required}
                validationErrors={addressCity.validationMessages}
                validations={addressCity.validations}
                value={form.addressCity}
            />
            {useSelect
                ?
                <ValidatingSelect
                    customClassNames="col-xs-12 col-lg-6 tp-input"
                    disabled={!form.recordIdentityKey}
                    key="state"
                    name={addressState.identifier}
                    onChange={this.handleFieldChange}
                    options={stateList}
                    required={addressState.required}
                    value={form.addressState}
                />
                : <ValidatingInput
                    customClassNames="col-xs-12 col-lg-6 tp-input"
                    disabled={!form.recordIdentityKey}
                    maxLength={32}
                    name={addressRegion.identifier}
                    onChange={this.handleFieldChange}
                    placeholder={this.getMsg('epic.esport.label.profile.region')}
                    required={addressRegion.required}
                    value={form.addressState}
                />
            }

            {form.addressCountryCode === 'US'
                ? <ValidatingInput
                    customClassNames="col-xs-12 col-lg-6 tp-input"
                    disabled={!form.recordIdentityKey}
                    name={addressZipCode.identifier}
                    onChange={this.handleFieldChange}
                    placeholder={this.getMsg('epic.esport.label.profile.postalCode')}
                    required={addressZipCode.required}
                    validationErrors={addressZipCode.validationMessages}
                    validations={addressZipCode.validations}
                    value={form.addressPostCode}
                />
                :
                <ValidatingInput
                    customClassNames="col-xs-12 col-lg-6 tp-input"
                    disabled={!form.recordIdentityKey}
                    name={addressZipCode.identifier}
                    onChange={this.handleFieldChange}
                    placeholder={this.getMsg('epic.esport.label.profile.postalCode')}
                    required={addressPostCode.required}
                    validationErrors={addressPostCode.validationMessages}
                    validations={addressPostCode.validations}
                    value={form.addressPostCode}
                />
            }
        </Fragment>);
    }

    MailingAddress = () => {
        const { taxProfile: { form } } = this.props;
        const {
            mailingAddressCity,
            mailingAddressLine1,
            mailingAddressLine2,
            mailingAddressPostCode,
            mailingAddressRegion,
            mailingAddressState,
            mailingAddressZipCode
        } = this.taxRecordSchema;

        // USA, Canada, Australia use predefine state lists
        const useSelect = ['US', 'CA', 'AU'].indexOf(form.mailingAddressCountryCode) > -1;
        let stateList;

        switch (form.mailingAddressCountryCode) {
            case 'US':
                stateList = statesFullNames;
                break;
            case 'CA':
                stateList = canadaProvinces;
                break;
            case 'AU':
                stateList = australiaStates;
                break;
            default:
                stateList = null;
        }
        return (<Fragment>
            <Heading className="col-xs-12 col-lg-12 tp-header" size={12}>{this.getMsg('epic.esport.profile.title.mailing')}</Heading>
            <ValidatingInput
                customClassNames="col-xs-12 col-lg-12 tp-input"
                disabled={!form.recordIdentityKey}
                maxLength={128}
                name={mailingAddressLine1.identifier}
                onChange={this.handleFieldChange}
                placeholder={this.getMsg('epic.esport.label.profile.address1')}
                required={mailingAddressLine1.required}
                validationErrors={mailingAddressLine1.validationMessages}
                validations={mailingAddressLine1.validations}
                value={form.mailingAddressLine1}
            />
            <ValidatingInput
                customClassNames="col-xs-12 col-lg-12 tp-input"
                disabled={!form.recordIdentityKey}
                maxLength={128}
                name={mailingAddressLine2.identifier}
                onChange={this.handleFieldChange}
                placeholder={this.getMsg('epic.esport.label.profile.address2')}
                required={mailingAddressLine2.required}
                validationErrors={mailingAddressLine2.validationMessages}
                validations={mailingAddressLine2.validations}
                value={form.mailingAddressLine2}
            />

            <ValidatingInput
                customClassNames="col-xs-12 col-lg-6 tp-input"
                disabled
                name="mailing_address_country"
                placeholder={this.getMsg('epic.esport.label.payoutInfo.country')}
                value={form.mailingAddressCountryCode}
            />
            <ValidatingInput
                customClassNames="col-xs-12 col-lg-6 tp-input"
                disabled={!form.recordIdentityKey}
                maxLength={128}
                name={mailingAddressCity.identifier}
                onChange={this.handleFieldChange}
                placeholder={this.getMsg('epic.esport.label.payoutInfo.city')}
                required={mailingAddressCity.required}
                validationErrors={mailingAddressCity.validationMessages}
                validations={mailingAddressCity.validations}
                value={form.mailingAddressCity}
            />
            {useSelect
                ?
                <ValidatingSelect
                    customClassNames="col-xs-12 col-lg-6 tp-input"
                    disabled={!form.recordIdentityKey}
                    key="state"
                    name={mailingAddressState.identifier}
                    onChange={this.handleFieldChange}
                    options={stateList}
                    required={mailingAddressState.required}
                    value={form.mailingAddressState}
                />
                : <ValidatingInput
                    customClassNames="col-xs-12 col-lg-6 tp-input"
                    disabled={!form.recordIdentityKey}
                    maxLength={32}
                    name={mailingAddressRegion.identifier}
                    onChange={this.handleFieldChange}
                    placeholder={this.getMsg('epic.esport.label.profile.region')}
                    required={mailingAddressRegion.required}
                    value={form.mailingAddressState}
                />
            }

            {form.addressCountryCode === 'US'
                ? <ValidatingInput
                    customClassNames="col-xs-12 col-lg-6 tp-input"
                    disabled={!form.recordIdentityKey}
                    name={mailingAddressZipCode.identifier}
                    onChange={this.handleFieldChange}
                    placeholder={this.getMsg('epic.esport.label.profile.postalCode')}
                    required={mailingAddressZipCode.required}
                    validationErrors={mailingAddressZipCode.validationMessages}
                    validations={mailingAddressZipCode.validations}
                    value={form.mailingAddressPostCode}
                />
                :
                <ValidatingInput
                    customClassNames="col-xs-12 col-lg-6 tp-input"
                    disabled={!form.recordIdentityKey}
                    name={mailingAddressPostCode.identifier}
                    onChange={this.handleFieldChange}
                    placeholder={this.getMsg('epic.esport.label.profile.postalCode')}
                    required={mailingAddressPostCode.required}
                    validationErrors={mailingAddressPostCode.validationMessages}
                    validations={mailingAddressPostCode.validations}
                    value={form.mailingAddressPostCode}
                />
            }
        </Fragment>);
    }

    TaxProfileStatus = () => {
        const { taxProfile: { taxDocuments, yearLength, taxDocRequestStatus }, getTaxDocuments } = this.props;

        const handleGetTaxDocuments = () => {
            if (taxDocRequestStatus === 'idle') {
                getTaxDocuments();
            }
        };

        const getYearList = () => {
            const thisYear = moment().year();
            const yearList = Array.from({ length: yearLength }, (_, i) => thisYear - i).map(x => ({label: x, value: x}));
            return [{label: this.getMsg('epic.esport.profile.placeholder.label.year'), value: '', disabled: true}, ...yearList];
        };

        const handleChangeYear = (year) => {
            this.setState({taxYear: Number(year)});
            this.setState({taxYearDocuments: taxDocuments.filter(it => it.taxYear === Number(year))});
        };

        return (
            <PrizeSpacer>
                <Formsy className="tax-profile-form">
                    <Heading size={14} className="reset-text-transform">{this.getMsg('epic.esport.profile.tax.form.title')}</Heading>
                    <Text size={14}>
                        <Message code="epic.esport.profile.label.tax.year" />
                    </Text>
                    <div className="row form-wrapper col-xs-12 col-md-9 col-lg-9">
                        <div className="form-field-wrapper col-xs-12 col-lg-6 tp-input">
                            <div className="select-div form-field form-field--custom reset-text-transform">
                                <i className="select-icon" />
                                <select
                                    className="select filled hide-text-transform"
                                    style={{color: !this.state.taxYear ? '#d2d2d2' : ''}}
                                    onClick={() => handleGetTaxDocuments()}
                                    onChange={(e) => handleChangeYear(e.target.value)}>
                                    {taxDocRequestStatus !== 'success' && <option value="">{this.getMsg('epic.esport.profile.placeholder.label.year')}</option>}
                                    {taxDocRequestStatus === 'success' && getYearList().map((year, index) => {
                                        return <option value={year.value} disabled={!!year.disabled} selected={!index}>{year.label}</option>;
                                    })}
                                </select>
                            </div>
                            {taxDocRequestStatus === 'loading' &&
                                <Loading className="tp-load loading-icon-size" />}
                        </div>
                        {taxDocRequestStatus === 'error' &&
                            <div className="tax-doc-error-message">{this.getMsg('errors.epic.common.unknown')}</div>}
                    </div>
                    <div className="row form-wrapper col-xs-12 col-md-9 col-lg-9">
                        <div className="form-field-wrapper col-xs-12 col-lg-12 tp-input">
                            {
                                !!this.state.taxYear && !!this.state.taxYearDocuments.length &&
                            <ul className="tax-documents">
                                {
                                    this.state.taxYearDocuments.map(doc => {
                                        return (
                                            <li>
                                                <div>
                                                    <Svg image={svgs.FILE} className="es-file__icon" />
                                                    <span>{this.getMsg('epic.esport.profile.tax.form.name', [doc.originalFieldName])}</span>
                                                </div>

                                                <a
                                                    href={`${Url().TAX.DOWNLOAD_TAX_PROFILE}?documentId=${doc.documentId}`}
                                                    download={doc.originalFieldName}>
                                                    <Svg image={svgs.DOWNLOAD} className="es-download__icon" />
                                                    {this.getMsg('epic.esport.profile.tax.form.btn.download')}
                                                </a>
                                            </li>
                                        );
                                    })
                                }
                            </ul>
                            }
                            {
                                !!this.state.taxYear && !this.state.taxYearDocuments.length && <div className="tax-form-not-found">
                                    <h2 className="not-found-header">{this.getMsg('epic.esport.profile.tax.form.notFound')}</h2>
                                    <Text size={14}>
                                        <Message code="epic.esport.profile.tax.form.message.reselect" />
                                    </Text>
                                </div>
                            }
                        </div>
                    </div>
                </Formsy>
            </PrizeSpacer>
        );
    }

    TaxProfileForm = () => {
        const { taxProfile: { form } } = this.props;
        const {addressCountryCode, mailingAddressCountryCode} = form;
        const isDiffCountry = !!addressCountryCode && !!mailingAddressCountryCode && (addressCountryCode !== mailingAddressCountryCode);

        return (
            <PrizeSpacer top={32}>
                <Formsy className="tax-profile-form" onValidSubmit={this.handleSubmit}>
                    <Heading size={14}>{this.getMsg('epic.esport.profile.title')}</Heading>
                    <Text size={14}>
                        <Message code="epic.esport.profile.info" />
                    </Text>

                    <div className="row form-wrapper col-xs-12 col-md-9 col-lg-9">
                        <ValidatingInput
                            customClassNames="col-xs-12 col-lg-6 tp-input"
                            disabled
                            name="firstName"
                            placeholder={this.getMsg('epic.esport.label.profile.firstName')}
                            value={form.firstName}
                        />
                        <ValidatingInput
                            customClassNames="col-xs-12 col-lg-6 tp-input"
                            disabled
                            name="lastName"
                            placeholder={this.getMsg('epic.esport.label.profile.lastName')}
                            value={form.lastName}
                        />
                        {
                            form.tin && <ValidatingInput
                                customClassNames="col-xs-12 col-lg-6 tp-input"
                                disabled
                                name="taxId"
                                placeholder={this.getMsg('epic.esport.placeholder.payoutInfo.TAXID')}
                                value={form.tin || form.foreignTin}
                            />
                        }
                        {
                            form.foreignTin && <ValidatingInput
                                customClassNames="col-xs-12 col-lg-6 tp-input"
                                disabled
                                name="taxId"
                                placeholder={this.getMsg('epic.esport.placeholder.payoutInfo.FOREIGN_TAXID')}
                                value={form.foreignTin}
                            />
                        }

                        {/* recordIdentityKey represents if a user has done a tax interview before */}

                        <this.PermanentAddress />

                        <div className="submit-button-wrapper col-xs-12 col-lg-12">
                            <ValidatingCheckbox
                                disabled={!form.recordIdentityKey || isDiffCountry}
                                checked={form.mailingAddressDifferent}
                                onClick={this.handleSwitchDiff}
                                name="mailingAddressDifferent">
                                {this.getMsg('epic.esport.profile.info.mailingAddress')}
                            </ValidatingCheckbox>
                        </div>

                        {
                            !!form.mailingAddressDifferent && <this.MailingAddress />
                        }

                        <div className="submit-button-wrapper">
                            <Button disabled={!form.recordIdentityKey}>
                                {this.getMsg('epic.esport.profile.saveChanges')}
                            </Button>
                        </div>
                    </div>
                </Formsy>
            </PrizeSpacer>
        );
    };

    GuardianProfileForm = () => {
        const { taxProfile: { form } } = this.props;
        const {
            guardianEmail,
            guardianFirstName,
            guardianLastName,
            guardianPhoneNumber
        } = this.taxRecordSchema;
        return (
            <PrizeSpacer top={32}>
                <Formsy className="tax-profile-form" onValidSubmit={this.showGuardianModal}>
                    <Heading>{this.getMsg('epic.esport.guardian.title')}</Heading>

                    <div className="row form-wrapper col-xs-12 col-md-9 col-lg-9">
                        <ValidatingInput
                            customClassNames="col-xs-12 col-lg-6 tp-input"
                            disabled={!form.recordIdentityKey}
                            maxLength={50}
                            name={guardianFirstName.identifier}
                            onChange={this.handleFieldChange}
                            placeholder={this.getMsg('epic.esport.label.profile.guardian.firstName')}
                            required={guardianFirstName.required}
                            validationErrors={guardianFirstName.validationMessages}
                            validations={guardianFirstName.validations}
                            value={form.guardianFirstName}
                        />
                        <ValidatingInput
                            customClassNames="col-xs-12 col-lg-6 tp-input"
                            disabled={!form.recordIdentityKey}
                            maxLength={50}
                            name={guardianLastName.identifier}
                            onChange={this.handleFieldChange}
                            placeholder={this.getMsg('epic.esport.label.profile.guardian.lastName')}
                            required={guardianLastName.required}
                            validationErrors={guardianLastName.validationMessages}
                            validations={guardianLastName.validations}
                            value={form.guardianLastName}
                        />
                        <ValidatingInput
                            customClassNames="col-xs-12 col-lg-6 tp-input"
                            disabled={!form.recordIdentityKey}
                            maxLength={128}
                            name={guardianEmail.identifier}
                            onChange={this.handleFieldChange}
                            placeholder={this.getMsg('epic.esport.label.profile.guardian.email')}
                            required={guardianEmail.required}
                            validationErrors={guardianEmail.validationMessages}
                            validations={guardianEmail.validations}
                            value={form.guardianEmail}
                        />
                        <ValidatingInput
                            customClassNames="col-xs-12 col-lg-6 tp-input"
                            disabled={!form.recordIdentityKey}
                            maxLength={17}
                            name={guardianPhoneNumber.identifier}
                            onChange={this.handleFieldChange}
                            placeholder={this.getMsg('epic.esport.label.profile.guardian.phone')}
                            required={guardianPhoneNumber.required}
                            validationErrors={guardianPhoneNumber.validationMessages}
                            validations={guardianPhoneNumber.validations}
                            value={form.guardianPhoneNumber}
                        />

                        <Text size={14} top={20} left={16}>
                            {this.getMsg('epic.esport.guardian.notice')}
                        </Text>

                        <div className="submit-button-wrapper">
                            <Button disabled={!form.recordIdentityKey}>
                                {this.getMsg('epic.esport.profile.saveChanges')}
                            </Button>
                        </div>
                    </div>
                </Formsy>
                <Modal
                    onClose={this.closeGuardianModal}
                    show={this.state.showGuardianModal}
                >
                    <div className="tax-profile-confirm">
                        <Text size={18}>
                            {this.getMsg('epic.esport.guardian.warning1')}
                        </Text>

                        <Text size={18} top={8}>
                            {this.getMsg('epic.esport.guardian.warning2')}
                        </Text>

                        <div className="tp-modal-btns">
                            <Button
                                variant="alt"
                                onClick={this.closeGuardianModal}
                                className="tp-btn"
                            >
                                {this.getMsg('epic.esport.profile.retake.no')}
                            </Button>
                            <Button
                                onClick={this.handleModalSubmit}
                                className="tp-btn"
                            >
                                {this.getMsg('epic.esport.profile.confirm')}
                            </Button>
                        </div>
                    </div>
                </Modal>
            </PrizeSpacer>
        );
    }

    render() {
        const {
            taxProfile: {
                loading,
                submitting,
                retakeAvailable,
                form: { dateOfBirth }
            },
            firstCanRetakePrize
        } = this.props;

        const elapsedYears = moment().diff(dateOfBirth, 'years');

        if (loading) {
            return <Loading className="tp-load" />;
        }

        return (
            <div>
                <this.TaxProfileStatus />
                <this.TaxProfileForm key="tax.form" />
                {!!elapsedYears && (elapsedYears < 18) &&
                    <this.GuardianProfileForm key="guardian.form" />
                }
                <PrizeSpacer top={32}>
                    <Heading>{this.getMsg('epic.esport.profile.retake.title')}</Heading>
                    <Text as="div" size={14}>
                        {this.getMsg('epic.esport.profile.retake.info')}
                    </Text>
                    <Text
                        as="div"
                        size={14}
                        weight="bold"
                        top={8}
                        bottom={24}
                    >
                        {this.getMsg('epic.esport.profile.retake.warning')}
                    </Text>
                    <Button
                        disabled={!retakeAvailable && !firstCanRetakePrize}
                        onClick={this.showRetakeModal}
                    >
                        {!retakeAvailable && firstCanRetakePrize ? this.getMsg('epic.esport.actions.startTaxInterview')
                            : this.getMsg('epic.esport.profile.retakeInterview')}
                    </Button>
                </PrizeSpacer>
                <Modal
                    onClose={this.closeRetakeModal}
                    show={this.state.showRetakeModal}
                >
                    {submitting
                        ? <Loading className="tp-load" />
                        : <div className="tax-profile-confirm">
                            <Text size={20}>
                                {this.getMsg('epic.esport.profile.retake.warning')}
                            </Text>
                            <Text size={20}>
                                {this.getMsg('epic.esport.profile.retake.continue')}
                            </Text>

                            <div className="tp-modal-btns">
                                <Button
                                    variant="alt"
                                    onClick={this.closeRetakeModal}
                                    className="tp-btn"
                                >
                                    {this.getMsg('epic.esport.profile.retake.no')}
                                </Button>
                                <Button
                                    onClick={this.onConfirm}
                                    className="tp-btn"
                                >
                                    {this.getMsg('epic.esport.profile.retake.yes')}
                                </Button>
                            </div>
                        </div>
                    }
                </Modal>
            </div>
        );
    }
}

export default withRouter(
    connect(
        mapStateToProps,
        mapDispatchProps
    )(TaxProfileForm)
);
